import { CloudForwarderForwarderInput } from "@graylog/enterprise-api";
const fetchResolvedForwarderInputs = async (ids) => {
  const response = await CloudForwarderForwarderInput.resolve(Array.from(new Set(ids)));
  return response.resolved.map((entry) => ({ type: "forwarder_input", ...entry }));
};
export default fetchResolvedForwarderInputs;
